module.exports = __webpack_public_path__ + "img/img4.cb831c11.png";